import { useSelector } from 'react-redux';

export function useMe() {
  const { user } = useSelector((state) => state.auth);

  return user;
}
